import { Dispatch, FormEvent, SetStateAction, useContext, useState } from "react";

import { StepModalData, WorkflowStepModel } from "../../../../../../../../../../../models";
import { ServiceError, Status } from "../../../../../../../../../../../service/Shared";
import { updateWorkflowStep } from "../../../../../../../../../../../service/workflow/WorkflowService.full";
import { useIsLoadingWrapper } from "../../../../../../../../../../../utils";
import { Toast } from "../../../../../../../../../../../widget";
import { TasksBoardContext } from "../../../../../../TasksBoardContext";

interface UseEditStepModalProps {
  closeModal: () => void;
  workflowStep: WorkflowStepModel;
}

interface UseEditStepModalReturnData {
  step: StepModalData;
  setStep: Dispatch<SetStateAction<StepModalData>>;

  handleEditStep: (e: FormEvent<HTMLFormElement>) => void;
  isHandleEditStepLoading: boolean;
  onCancel: () => void;
  errors: ServiceError[];
}

export const useEditStepModal = ({ closeModal, workflowStep }: UseEditStepModalProps): UseEditStepModalReturnData => {
  const { shouldRefreshTasksBoard, isRepeatableWorkflowStage } = useContext(TasksBoardContext);
  const [isHandleEditStepLoading, setIsHandleEditStepLoading] = useState(false);
  const [errors, setErrors] = useState<ServiceError[]>([]);

  const [step, setStep] = useState<StepModalData>({
    stepName: workflowStep.name,
    phase: workflowStep.phase,
    isRepeatable: workflowStep.isRepeatable,
  });

  const onCancel = (): void => {
    setErrors([]);
    setStep({
      stepName: workflowStep.name,
      phase: workflowStep.phase,
      isRepeatable: workflowStep.isRepeatable,
    });
    closeModal();
  };

  const handleEditStep = useIsLoadingWrapper(async (e: FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();
    setErrors([]);

    const res = await updateWorkflowStep({
      workflowStepUuid: workflowStep.uuid,
      stepName: step.stepName as string,
      phase: step.phase as string,
      isRepeatable: isRepeatableWorkflowStage(step.phase) ? (step.isRepeatable as boolean) : false,
      rowVersion: workflowStep.rowVersion,
    });

    if (res.status === Status.Success) {
      Toast.success({ message: "Workflow step successfully updated" });
      shouldRefreshTasksBoard();
      closeModal();
    }
    if (res.status === Status.Error && res.errors) {
      setErrors(res.errors);
    }
  }, setIsHandleEditStepLoading);

  return { step, setStep, isHandleEditStepLoading, handleEditStep, onCancel, errors };
};
